import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import "us.style/antd.less";
import "us.style/index.scss";
import "us.helper/utility/dayjsConfig";

import { Loader } from "us.common/components";

import App from "App";
import * as serviceWorker from "serviceWorker";
import store from "store";
import * as Azure from "us.helper/azure";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { setupTitle } from "us.helper";
import { MsalProvider } from "@azure/msal-react";

window.APP_MODULE = "ci";

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(Azure.msalConfig);

// Handle default account selection
const accounts = msalInstance.getAllAccounts();
if (!msalInstance.getActiveAccount() && accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

// Sync account state across tabs
msalInstance.enableAccountStorageEvents();

// MSAL event handling
msalInstance.addEventCallback((event: EventMessage) => {
  if (
    [EventType.LOGIN_SUCCESS, EventType.SSO_SILENT_SUCCESS].includes(
      event.eventType
    ) &&
    event.payload
  ) {
    const payload = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  } else if (event.eventType === EventType.LOGOUT_SUCCESS) {
    msalInstance.setActiveAccount(null);
    window.location.reload();
  } else if (event.eventType === EventType.ACCOUNT_ADDED && event.payload) {
    const payload = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  } else if (event.eventType === EventType.ACCOUNT_REMOVED) {
    msalInstance.setActiveAccount(null);
    window.location.reload();
  }
});

// Setup page title dynamically
setupTitle();

// Mount React App
const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <Suspense fallback={<Loader />}>
          <App />
        </Suspense>
      </MsalProvider>
    </Provider>
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
